var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.errors[''] && _vm.errors[''].includes('Request body too large'))?_c('v-alert',{staticClass:"mb-0 w-full",attrs:{"dense":"","type":"error"}},[_vm._v(" "+_vm._s(_vm.$t("components.requestSizeError.uploadFailed"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }